import {useEffect, useRef, useState} from "react";
import {Link, useLocation, useNavigate} from "react-router-dom";
import {Button, Form} from "react-bootstrap";

import AuthenticationLayout from "../layouts/AuthenticationLayout";
import InputField from "../components/InputField";
import {useUser} from "../contexts/UserProvider";
import useTranslation from "../hooks/translations";
import {toast} from "react-toastify";

export default function LoginPage() {
  const translations = useTranslation();
  const {login} = useUser();

  const location = useLocation();
  const navigate = useNavigate();

  const emailField = useRef();
  const passwordField = useRef();
  const [formErrors, setFormErrors] = useState({});

  useEffect(() => {
    emailField.current.focus();
  }, []);

  const onSubmit = async (event) => {
    event.preventDefault();
    const username = emailField.current.value;
    const password = passwordField.current.value;

    const errors = {};
    if (!username) {
      errors.email = translations.errorEmail;
    }
    if (!password) {
      errors.password = translations.errorPassword;
    }
    setFormErrors(errors);
    if (Object.keys(errors).length > 0) {
      return;
    }

    const result = await login(username, password)
    if (result.status === 'fail') {
      toast.error(translations.apiLoginError)
    } else if (result.status === 'ok') {
      let next = '/costs';
      if (result.roles) {
        if (result.roles.includes("Admin") || result.roles.includes("Moderator")) {
          next = '/'
        }
      }
      if (location.state && location.state.next) {
        next = location.state.next;
      }
      navigate(next);
    }
  };

  return (
    <AuthenticationLayout>
      <div className="col-lg-5">
        <div className="card shadow-lg border-0 rounded-lg mt-5">
          <div className="card-header justify-content-center">
            <h3 className="fw-light my-4">{translations.login}</h3>
          </div>
          <div className="card-body">
            <Form onSubmit={onSubmit}>
              <div className="mb-3">
                <InputField
                  name="inputEmailAddress"
                  label={translations.email}
                  placeholder={translations.enterEmail}
                  error={formErrors.email}
                  fieldRef={emailField}
                  maxLength={120}
                />
              </div>
              <div className="mb-3">
                <InputField
                  type="password"
                  name="inputPassword"
                  label={translations.password}
                  placeholder={translations.enterPassword}
                  error={formErrors.password}
                  fieldRef={passwordField}
                />
              </div>
              {/*<div className="mb-3">*/}
              {/*  <div className="form-check">*/}
              {/*    <input className="form-check-input" id="rememberPasswordCheck"*/}
              {/*           type="checkbox" value=""/>*/}
              {/*    <label className="form-check-label"*/}
              {/*           htmlFor="rememberPasswordCheck">Remember*/}
              {/*      password</label>*/}
              {/*  </div>*/}
              {/*</div>*/}
              <div
                className="d-flex align-items-center justify-content-between mt-4 mb-0">
                <Link className="small"
                      to="/forgot-password">{translations.forgotPassword}</Link>
                <Button variant="primary"
                        type="submit">{translations.login}</Button>
              </div>
            </Form>
          </div>
          {/*<div className="card-footer text-center">*/}
          {/*  <div className="small">*/}
          {/*    <Link to="/register">Need an account? Sign up!</Link>*/}
          {/*  </div>*/}
          {/*</div>*/}
        </div>
      </div>
    </AuthenticationLayout>
  )
}
